import styled from 'styled-components';
import { Card } from 'antd';
import { FONT_SIZE, FONT_WEIGHT } from '@app/styles/themes/constants';

interface StatisticCardProps {
  $color: string;
}

export const StatisticCard = styled(Card)<StatisticCardProps>`
  cursor: pointer;
  transition: all 0.3s ease;
  border-left: 4px solid ${(props) => props.$color};
  
  &:hover {
    transform: translateY(-4px);
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
  }

  .ant-card-body {
    display: flex;
    align-items: center;
    padding: 1.5rem;
  }
`;

export const StatisticIcon = styled.div`
  font-size: 2.5rem;
  margin-right: 1rem;
`;

export const StatisticContent = styled.div`
  flex: 1;
`;

export const StatisticValue = styled.div`
  font-size: ${FONT_SIZE.xxl};
  font-weight: ${FONT_WEIGHT.bold};
  color: var(--text-main-color);
  line-height: 1.2;
`;

export const StatisticTitle = styled.div`
  font-size: ${FONT_SIZE.md};
  color: var(--text-main-color);
  margin-top: 0.25rem;
  opacity: 0.7;
`;

export const QuickActions = styled.div`
  display: flex;
  flex-direction: column;
`;

export const ActivitiesList = styled.div`
  display: flex;
  flex-direction: column;
  gap: 1rem;
  max-height: 500px;
  overflow-y: auto;
`;

export const ActivityItem = styled.div`
  display: flex;
  align-items: flex-start;
  padding: 0.75rem;
  border-radius: 8px;
  background: var(--background-color);
  transition: background 0.2s;

  &:hover {
    background: var(--item-hover-bg);
  }
`;

export const ActivityIcon = styled.div`
  font-size: 1.5rem;
  margin-right: 0.75rem;
  flex-shrink: 0;
`;

export const ActivityContent = styled.div`
  flex: 1;
  min-width: 0;
`;

export const ActivityDescription = styled.div`
  font-size: ${FONT_SIZE.md};
  color: var(--text-main-color);
  margin-bottom: 0.25rem;
`;

export const ActivityMeta = styled.div`
  font-size: ${FONT_SIZE.xs};
  color: var(--text-main-color);
  opacity: 0.7;
  margin-bottom: 0.25rem;
`;

export const ActivityDate = styled.div`
  font-size: ${FONT_SIZE.xs};
  color: var(--text-main-color);
  opacity: 0.5;
`;

